__turbopack_context__.v({
  "banner": "HjA3Za_banner",
  "container": "HjA3Za_container",
});
